import _hasOwn from "./hasOwn";
import _every from "./every";
import _isObject from "../lang/isObject";
import _is from "../lang/is";

var _global = typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : global;

var exports = {};
var hasOwn = _hasOwn;
var every = _every;
var isObject = _isObject;
var is = _is; // Makes a function to compare the object values from the specified compare
// operation callback.

function makeCompare(callback) {
  return function (value, key) {
    return hasOwn(this || _global, key) && callback(value, (this || _global)[key]);
  };
}

function checkProperties(value, key) {
  return hasOwn(this || _global, key);
}
/**
 * Checks if two objects have the same keys and values.
 */


function equals(a, b, callback) {
  callback = callback || is;

  if (!isObject(a) || !isObject(b)) {
    return callback(a, b);
  }

  return every(a, makeCompare(callback), b) && every(b, checkProperties, a);
}

exports = equals;
export default exports;